<script setup lang="ts">
import usePoolStore from '~~/app/store/pool'
</script>

<template>
    <div class="text-gray-l-500 text-0.5sm flex">
        <span class="w-1/2 block">{{ $t('covered_area') }}</span>
        <span class="w-1/2 block">
            {{ usePoolStore().isIndoor ? $t('yes') : $t('no') }}
        </span>
    </div>
</template>
